import {BoltOutlined, EvStationOutlined, TaskAltOutlined} from '@mui/icons-material';
import {FC} from 'react';
import {useIntl} from 'react-intl';
import {StatsStrip} from 'src/components/common/StatsStrip';
import {SessionStatus} from 'src/components/chargingSessions/ChargingSessionsTable';
import {SessionStats} from 'src/types/stats';

interface SessionStatsStripProps {
    data?: SessionStats;
    activeStatus: SessionStatus;
    onSelectStatus: (status: SessionStatus) => void;
}

/**
 * The block every list opens with, for sessions: how many there are, how many are running now and how
 * many have ended. The three are one axis - picking one replaces the other, and All is the way back.
 */
export const SessionStatsStrip: FC<SessionStatsStripProps> = ({data, activeStatus, onSelectStatus}) => {
    const intl = useIntl();

    return (
        <StatsStrip
            icon={<BoltOutlined/>}
            title="chargingSessions"
            subtitle={intl.formatMessage({id: 'sessionStatsSubtitle'}, {sessions: data?.sessions ?? 0})}
            tiles={[
                {
                    key: 'all',
                    label: 'sessionsAll',
                    value: data?.sessions,
                    icon: <BoltOutlined/>,
                    tone: 'primary',
                    active: activeStatus === 'all',
                    onClick: () => onSelectStatus('all'),
                },
                {
                    key: 'active',
                    label: 'sessionsActive',
                    value: data?.active,
                    icon: <EvStationOutlined/>,
                    tone: 'success',
                    active: activeStatus === 'active',
                    onClick: () => onSelectStatus('active'),
                },
                {
                    key: 'completed',
                    label: 'sessionsCompleted',
                    value: data?.completed,
                    icon: <TaskAltOutlined/>,
                    tone: 'neutral',
                    active: activeStatus === 'completed',
                    onClick: () => onSelectStatus('completed'),
                },
            ]}
        />
    );
};
